export const BILLING_GROUPS = {
  CALLS: '1',
  SMS: '4',
  INTERNET: '3',
  DISCOUNTS: '13',
}
